// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml,\nbody,\n.index_app_3Qs6X {\n    /* probably unnecessary, transitional until layout is refactored */\n    /* width: 100%; */\n    margin: 0;\n\n    /* Setting min height/width makes the UI scroll below those sizes */\n    /* min-width: 1024px; */\n    /* min-height: 640px; Min height to fit sprite/backdrop button */\n}\n\n/* @todo: move globally? Safe / side FX, for blocks particularly? */\n\n/* * { box-sizing: border-box; } */\n", ""]);
// Exports
exports.locals = {
	"app": "index_app_3Qs6X"
};
module.exports = exports;
